import { baseUrl } from '@/config/apiConfig.js';

const base1 = 'https://test.mureka.ai'
export function apiUserInfo(fetchFn) {
  return fetchFn(`${baseUrl}/api/pgc/profile`, {}, { method: 'get' })
}